import React from "react";
import { FiInfo, FiX } from "react-icons/fi";

const INFO_DATA = [
  {
    title: "New Orders",
    badge: "New",
    color: "bg-pink-50 text-pink-700 border-pink-200",
    desc: "Shows only fresh orders in the Ordering stage where no quotation has been submitted yet.",
  },
  {
    title: "Dispatched Orders",
    badge: "Dispatched",
    color: "bg-blue-50 text-blue-700 border-blue-200",
    desc: "Shows orders where dispatch has started — either a sample batch or full order has been sent out.",
  },
  {
    title: "Completed Orders",
    badge: "Completed",
    color: "bg-emerald-50 text-emerald-700 border-emerald-200",
    desc: "Shows orders that are fully delivered, payments settled, and marked as completed.",
  },
  {
    title: "Attention Indicator (Blinking Border)",
    badge: "Alert",
    color: "bg-amber-50 text-amber-700 border-amber-200",
    desc: "When a new open order has 0 quotations submitted, the card pulses with a highlighted border to grab your attention.",
  },
];

const SupplierIncomingOrdersInfoModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm animate-fadeIn">
      <div
        className="relative w-full max-w-lg bg-white rounded-2xl shadow-2xl border border-gray-100 overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100 bg-gray-50/50">
          <div className="flex items-center gap-2.5">
            <div className="w-8 h-8 rounded-lg bg-primaryColor/10 text-primaryColor flex items-center justify-center">
              <FiInfo className="text-lg" />
            </div>
            <div>
              <h3 className="font-bold text-gray-800 text-base">
                About Live Orders
              </h3>
              <p className="text-xs text-gray-400">
                Guide to managing your supplier incoming orders
              </p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="w-8 h-8 rounded-lg text-gray-400 hover:text-gray-600 hover:bg-gray-100 flex items-center justify-center transition"
          >
            <FiX className="text-lg" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 space-y-4 max-h-[70vh] overflow-y-auto">
          {INFO_DATA.map((item, idx) => (
            <div
              key={idx}
              className="p-3.5 rounded-xl border border-gray-100 hover:border-primaryColor/20 bg-white hover:bg-primaryColor/[0.02] transition"
            >
              <div className="flex items-center justify-between mb-1.5">
                <span className="font-semibold text-sm text-gray-800">
                  {idx + 1}. {item.title}
                </span>
                <span
                  className={`text-[10px] font-bold px-2 py-0.5 rounded-full border ${item.color}`}
                >
                  {item.badge}
                </span>
              </div>
              <p className="text-xs text-gray-600 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>

        {/* Footer */}
        <div className="px-6 py-4 border-t border-gray-100 bg-gray-50/50 flex justify-end">
          <button
            onClick={onClose}
            className="px-5 py-2 rounded-xl bg-primaryColor text-white text-sm font-semibold hover:bg-primaryColor/90 transition shadow-sm"
          >
            Got it
          </button>
        </div>
      </div>
    </div>
  );
};

export default SupplierIncomingOrdersInfoModal;
